import React, { Component } from 'react';
import { TabPanel }      from 'primereact/tabview';
import { TabViewComErro } from 'hay-core-react';
import { SplitButton }       from 'primereact/splitbutton';
import { Dialog }            from 'primereact/dialog';
import { confirmDialog }     from 'primereact/confirmdialog';

import { EntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelUrl } from 'hay-core-react';
import { ModelTextArea } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelBoolean } from 'hay-core-react';
import { ModelSenha } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import { TooltipService } from 'hay-core-react';
import Routerboard             from '../../../models/Routerboard';
import RouterboardTipoEnum     from '../../../enums/RouterboardTipoEnum';
import HomologacaoRouterboard  from '../../../models/HomologacaoRouterboard';
import RouterboardProvisionarPanel from './RouterboardProvisionarPanel';
import RouterboardResultados from './RouterboardResultados';

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    // ── Inicialmente visíveis no grid (V) ────────────────────────────────────
    id:            { exibir: 'main.id',                        tipo: 'numeric', largura: '5rem', fixar: true },
    descricao:     { exibir: 'main.routerboard.descricao',     visivel: true, validacao: { obrigatorio: true } },
    enderecoip:    { exibir: 'main.routerboard.enderecoip',    visivel: true, validacao: { obrigatorio: true } },
    tipo:          { exibir: 'main.routerboard.tipo',          visivel: true, tipo: 'enum', entidade: 'routerboard.tipo' },
    versaohomologada: {
        exibir:       'main.routerboard.versaohomologada',
        visivel:      true,
        tipo:         'relacao',
        camporelacao: 'descricao',
        entidade:     'versaohomologada.entidade',
        template:     'versaohomologada.template',
        validacao:    { obrigatorio: true },
        filtro: (contexto) => ({
            tipo:         { constraints: [{ value: contexto.state.model.tipo?.value, matchMode: 'equals' }] },
            homologadoem: { constraints: [{ value: 0, matchMode: 'gt' }] },
        }),
    },
    ativo:         { exibir: 'main.routerboard.ativo',         visivel: true, tipo: 'boolean', template: 'ativo.template' },
    homologacao:   { exibir: 'main.routerboard.homologacao',   visivel: true, tipo: 'boolean', template: 'homologacao.template' },
    // ── Disponíveis no configurador, ocultas por padrão (G) ─────────────────
    hostname:      { exibir: 'main.routerboard.hostname',      validacao: { obrigatorio: true } },
    porta:         { exibir: 'main.routerboard.porta',         tipo: 'numeric', keyfilter: 'num' },
    usuario:       { exibir: 'main.routerboard.usuario',       validacao: { obrigatorio: true } },
    seguro:        { exibir: 'main.routerboard.seguro',        tipo: 'boolean', template: 'seguro.template' },
    interfacerede: { exibir: 'main.routerboard.interfacerede', validacao: { obrigatorio: true } },
    rede:          { exibir: 'main.routerboard.rede', validacao: { obrigatorio: true } },
    redirecionar:  { exibir: 'main.routerboard.redirecionar', tipo: 'url', validacao: { url: true } },
    configurarwifi: { exibir: 'main.routerboard.configurarwifi', tipo: 'boolean', template: 'configurarwifi.template' },
    // Sem validacao.obrigatorio — o campo só é exibido/preenchido quando configurarwifi está
    // marcado (ver RouterboardFormulario abaixo); a obrigatoriedade de fato é garantida no
    // backend (Routerboard.gerarScript), na hora que realmente importa.
    ssid:          { exibir: 'main.routerboard.ssid' },
    // ── Apenas formulário (F) ────────────────────────────────────────────────
    senha:         { exibir: 'main.routerboard.senha',         validacao: { obrigatorio: true } },
    script:        { exibir: 'main.routerboard.script',        linhas: 10 },
};

// ─── Renderers customizados ───────────────────────────────────────────────────

const booleanTemplate = (campo) => (rowData) => (
    <i className={`pi ${rowData[campo] ? 'pi-check text-green-500' : 'pi-times text-red-400'}`}></i>
);

const renderers = {
    ativo:              { template: booleanTemplate('ativo') },
    homologacao:        { template: booleanTemplate('homologacao') },
    seguro:             { template: booleanTemplate('seguro') },
    configurarwifi:     { template: booleanTemplate('configurarwifi') },
    'routerboard.tipo': RouterboardTipoEnum,
    versaohomologada: {
        entidade: HomologacaoRouterboard,
        template: (rowData) => rowData.versaohomologada?.descricao || '',
    },
};

// ─── Formulário de campos (render prop) ───────────────────────────────────────

class RouterboardFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        const routerboard = UtilService.extrairModel(model);
        return (
            <TabViewComErro tentativaSalvar={contexto.state.tentativaSalvar} className="col-12 mt-2">
                <TabPanel header={UtilService.traduzir('main.routerboard.aba.basica')} leftIcon="pi pi-home mr-2">
                    <div className="grid">
                        <div className="field col-12 md:col-8 mt-3">
                            <ModelTextInput model={model.descricao} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelDropDown model={model.tipo} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelDropDown model={model.versaohomologada} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.enderecoip} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.hostname} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.porta} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.usuario} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelSenha model={model.senha} contexto={contexto} mostrarMetricas={false} />
                        </div>
                        <div className="field col-12 md:col-3 mt-3">
                            <ModelBoolean model={model.ativo} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelUrl model={model.redirecionar} contexto={contexto} />
                        </div>                        
                        <div className="field col-12 md:col-3 mt-3">
                            <ModelBoolean model={model.seguro} contexto={contexto} />
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header={UtilService.traduzir('main.routerboard.aba.script')} leftIcon="pi pi-code mr-2">
                    <div className="grid">
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.interfacerede} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.rede} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelBoolean model={model.homologacao} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelBoolean model={model.configurarwifi} contexto={contexto} />
                        </div>
                        {model.configurarwifi.value && (
                            <div className="field col-12 md:col-4 mt-3">
                                <ModelTextInput model={model.ssid} contexto={contexto} />
                            </div>
                        )}
                        <div className="field col-12 mt-3">
                            <ModelTextArea model={model.script} contexto={contexto} />
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header={UtilService.traduzir('main.routerboard.aba.provisionar')} leftIcon="pi pi-sitemap mr-2">
                    <RouterboardProvisionarPanel routerboard={routerboard} contexto={contexto} />
                </TabPanel>
            </TabViewComErro>
        );
    }
}

// ─── Footer do formulário ─────────────────────────────────────────────────────

async function chamarAcao(fn, chavesSucesso, chavesErro) {
    const res = await fn();
    if (res?.status) {
        UtilService.showToast({ severity: 'success', summary: UtilService.traduzir(chavesSucesso), detail: RouterboardResultados.testarConexao(res) });
    } else {
        UtilService.showToast({
            severity: 'error',
            summary:  UtilService.traduzir(res?.data?.state || chavesErro),
            detail:   RouterboardResultados.testarConexao(res),
        });
    }
    return res;
}

async function chamarAcaoGerarScript(fn, contexto, descricaoEquipamento) {
    const res = await fn();
    if (res?.status) {
        contexto.updateModelPath('script.value', res?.data?.script);
        UtilService.showToast({
            severity: 'success',
            summary:  UtilService.traduzir('main.routerboard.gerarscript.sucesso'),
            detail:   RouterboardResultados.gerarScript(res, descricaoEquipamento),
        });
    } else {
        UtilService.showToast({
            severity: 'error',
            summary:  UtilService.traduzir(res?.data?.state || 'main.routerboard.gerarscript.erro'),
            detail:   RouterboardResultados.gerarScript(res, descricaoEquipamento),
        });
    }
    return res;
}

async function chamarAcaoExecutarScript(fn, descricaoEquipamento) {
    const res = await fn();
    if (res?.status) {
        UtilService.showToast({
            severity: 'success',
            summary:  UtilService.traduzir('main.routerboard.executarscript.sucesso'),
            detail:   RouterboardResultados.executarScript(res, descricaoEquipamento),
        });
    } else {
        UtilService.showToast({
            severity: 'error',
            summary:  UtilService.traduzir(res?.data?.state || 'main.routerboard.executarscript.erro'),
            detail:   RouterboardResultados.executarScript(res, descricaoEquipamento),
        });
    }
    return res;
}

// res?.data?.retorno aqui é saída crua de texto do comando SSH (não o JSON de /system/resource
// da REST API que chamarAcao espera em retorno.version) — por isso não reaproveita chamarAcao.
async function chamarAcaoTestarSsh(fn) {
    const res = await fn();
    if (res?.status) {
        UtilService.showToast({
            severity: 'success',
            summary:  UtilService.traduzir('main.routerboard.testarssh.sucesso'),
            detail:   RouterboardResultados.testarSsh(res),
        });
    } else {
        UtilService.showToast({
            severity: 'error',
            summary:  UtilService.traduzir(res?.data?.state || 'main.routerboard.testarssh.erro'),
            detail:   RouterboardResultados.testarSsh(res),
        });
    }
    return res;
}

async function chamarAcaoAtivarApi(fn, descricaoEquipamento) {
    const res = await fn();
    if (res?.status) {
        UtilService.showToast({
            severity: 'success',
            summary:  UtilService.traduzir('main.routerboard.ativarapi.sucesso'),
            detail:   RouterboardResultados.ativarApi(res, descricaoEquipamento),
        });
    } else {
        UtilService.showToast({
            severity: 'error',
            summary:  UtilService.traduzir(res?.data?.state || 'main.routerboard.ativarapi.erro'),
            detail:   RouterboardResultados.ativarApi(res, descricaoEquipamento),
        });
    }
    return res;
}

// `sticky` no erro (card Trello #105): o detalhe da falha agora carrega o diagnóstico real vindo
// do equipamento (motivo recusado pelo RouterOS + as linhas do log da própria Routerboard sobre a
// tentativa), texto longo demais pra ser lido nos 3s de vida padrão de um toast. Só o caminho de
// erro é sticky - o de sucesso continua sumindo sozinho.
async function chamarAcaoAtivarSslLetsEncrypt(fn, descricaoEquipamento) {
    const res = await fn();
    if (res?.status) {
        UtilService.showToast({
            severity: 'success',
            summary:  UtilService.traduzir('main.routerboard.ativarsslletsencrypt.sucesso'),
            detail:   RouterboardResultados.ativarSslLetsEncrypt(res, descricaoEquipamento),
        });
    } else {
        UtilService.showToast({
            severity: 'error',
            sticky:   true,
            summary:  UtilService.traduzir(res?.data?.state || 'main.routerboard.ativarsslletsencrypt.erro'),
            detail:   RouterboardResultados.ativarSslLetsEncrypt(res, descricaoEquipamento),
        });
    }
    return res;
}

// Envolve o conteúdo padrão do item (options.element, já com ícone/label) num wrapper com o
// atributo nativo `title`. Os itens do model do SplitButton não têm prop tooltip própria (ao
// contrário de um Button avulso) — e um <Tooltip target="seletor"> do PrimeReact não funciona
// aqui: ele resolve o seletor uma única vez logo após o primeiro re-render, momento em que o
// dropdown ainda está fechado e os itens (renderizados num portal só quando o menu abre) ainda
// não existem no DOM; como o seletor nunca muda depois, o PrimeReact nunca refaz essa busca e os
// itens nunca recebem o listener. `title` é resolvido pelo próprio navegador a cada hover, sem
// depender de quando o nó entra no DOM.
function itemComHelp(item, help) {
    return {
        ...item,
        template: (it, options) => (
            <div className="w-full" title={help}>
                {options.element}
            </div>
        ),
    };
}

class RouterboardFooter extends Component {

    state = { statusConexao: null };

    testarConexao = async (routerboard) => {
        const res = await chamarAcao(
            () => Routerboard.testarConexao(routerboard),
            'main.routerboard.testarconexao.sucesso',
            'main.routerboard.testarconexao.erro',
        );
        this.setState({ statusConexao: res?.status ? 'ok' : 'erro' });
    }

    salvarEExecutarScript = async (routerboard, contexto) => {
        const salvou = await contexto.salvar(false);
        if (!salvou) return;
        await chamarAcaoExecutarScript(() => Routerboard.executarScript(routerboard), routerboard.descricao);
    }

    // O comando de ativar API (comandoativarapi) termina com `/system device-mode update
    // hotspot=yes fetch=yes` — no RouterOS, mudanças de device-mode só valem depois que o usuário
    // aperta fisicamente o botão MODE ou RESET do equipamento, em até 5 minutos; a própria conexão
    // SSH fica bloqueada esperando esse reinício, então a requisição só retorna bem depois disso
    // (não dá pra avisar num Dialog "depois que o comando terminar" — isso só aconteceria já com
    // o equipamento reiniciado). Por isso confirma ANTES de disparar o comando, e o aviso do botão
    // fica na MENSAGEM DE LOADING (visível durante toda a espera), não num Dialog posterior — sem
    // contagem regressiva, já que o processo em si aguarda o reinício manual, sem prazo que o
    // frontend precise controlar.
    //
    // setTimeout: abrir o confirm no mesmo tick do clique do item do SplitButton (que ainda está
    // fechando seu próprio menu/overlay) fazia o confirm não aparecer — adiado pro próximo tick
    // evita esse conflito de overlays sobrepostos.
    //
    // Idempotência (card Trello #104): device-mode hotspot/fetch só exige a confirmação física
    // (botão MODE/RESET) quando MUDA de no->yes — se já estão ativos (comando já rodou antes com
    // sucesso), reenviar `/system device-mode update hotspot=yes fetch=yes` é um no-op nessa
    // parte, sem reinício pendente, então o aviso de confirm não faz sentido: pula direto pra
    // ativarApi. Checagem via backend (SSH, mesmo canal do próprio ativarApi).
    confirmarEAtivarApi = async (routerboard) => {
        const resultado = await Routerboard.verificarDeviceModeAtivo(routerboard);
        if (resultado?.data?.ativo) {
            this.ativarApi(routerboard, true);
            return;
        }
        setTimeout(() => {
            confirmDialog({
                header:       UtilService.traduzir('main.routerboard.ativarapi.confirmacao.header'),
                message:      UtilService.traduzir('main.routerboard.ativarapi.confirmacao.mensagem'),
                icon:         'pi pi-exclamation-triangle',
                className:    'w-4',
                draggable:    false,
                defaultFocus: 'reject',
                acceptClassName: 'p-button-warning',
                accept: () => this.ativarApi(routerboard),
            });
        }, 1);
    }

    // `deviceModeJaAtivo` (setado por confirmarEAtivarApi quando pula o confirm) troca a mensagem
    // de loading — a versão padrão instrui a apertar o botão MODE/RESET, o que confundiria o
    // usuário quando o device-mode já está ativo e nenhum reinício vai acontecer.
    ativarApi = async (routerboard, deviceModeJaAtivo) => {
        const mensagemLoading = UtilService.traduzir(deviceModeJaAtivo
            ? 'main.routerboard.ativarapi.aviso.mensagem.semreinicio'
            : 'main.routerboard.ativarapi.aviso.mensagem');
        await chamarAcaoAtivarApi(() => Routerboard.ativarApi(routerboard, mensagemLoading), routerboard.descricao);
        UtilService.hideLoading();
    }

    // Mesmo raciocínio de confirmarEAtivarApi (setTimeout pro confirm não ser engolido pelo
    // overlay do SplitButton se fechando) - aqui a confirmação também reforça os pré-requisitos
    // (porta 80 + DNS) antes de disparar o comando, já que a validação de DNS no backend só barra
    // DEPOIS de clicar, e o usuário precisa saber o que corrigir se isso acontecer.
    confirmarEAtivarSslLetsEncrypt = (routerboard) => {
        setTimeout(() => {
            confirmDialog({
                header:       UtilService.traduzir('main.routerboard.ativarsslletsencrypt.confirmacao.header'),
                message:      UtilService.traduzir('main.routerboard.ativarsslletsencrypt.confirmacao.mensagem'),
                icon:         'pi pi-exclamation-triangle',
                className:    'w-4',
                draggable:    false,
                defaultFocus: 'reject',
                acceptClassName: 'p-button-warning',
                accept: () => this.ativarSslLetsEncrypt(routerboard),
            });
        }, 1);
    }

    ativarSslLetsEncrypt = async (routerboard) => {
        const mensagemLoading = UtilService.traduzir('main.routerboard.ativarsslletsencrypt.aviso.mensagem');
        await chamarAcaoAtivarSslLetsEncrypt(() => Routerboard.ativarSslLetsEncrypt(routerboard, mensagemLoading), routerboard.descricao);
        UtilService.hideLoading();
    }

    render() {
        const { model, contexto } = this.props;
        const id = model?.id?.value;
        const routerboard = UtilService.extrairModel(model);
        const { statusConexao } = this.state;
        const itens = [
            itemComHelp({
                label:   UtilService.traduzir('main.routerboard.gerarscript'),
                icon:    'pi pi-file-edit',
                command: () => chamarAcaoGerarScript(
                    () => Routerboard.gerarScript(routerboard),
                    contexto,
                    routerboard.descricao,
                ),
            }, contexto.traduzirHelp('gerarscript')),
            itemComHelp({
                label:   UtilService.traduzir('main.routerboard.executarscript'),
                icon:    'pi pi-play',
                command: () => this.salvarEExecutarScript(routerboard, contexto),
            }, contexto.traduzirHelp('executarscript')),
            itemComHelp({
                label:   UtilService.traduzir('main.routerboard.testarssh'),
                icon:    'pi pi-desktop',
                command: () => chamarAcaoTestarSsh(() => Routerboard.testarSsh(routerboard)),
            }, contexto.traduzirHelp('testarssh')),
            ...(model.versaohomologada?.value?.comandoativarapi ? [itemComHelp({
                label:   UtilService.traduzir('main.routerboard.ativarapi'),
                icon:    'pi pi-key',
                command: () => this.confirmarEAtivarApi(routerboard),
            }, contexto.traduzirHelp('ativarapi'))] : []),
            ...(model.versaohomologada?.value?.comandoativarsslletsencrypt ? [itemComHelp({
                label:   UtilService.traduzir('main.routerboard.ativarsslletsencrypt'),
                icon:    'pi pi-lock',
                command: () => this.confirmarEAtivarSslLetsEncrypt(routerboard),
            }, contexto.traduzirHelp('ativarsslletsencrypt'))] : []),
        ];
        const icone = statusConexao === 'ok'    ? 'pi pi-wifi text-green-500'
                    : statusConexao === 'erro'   ? 'pi pi-wifi text-red-500'
                    :                              'pi pi-wifi';
        return (
            <SplitButton
                label={UtilService.traduzir('main.routerboard.testarconexao')}
                icon={icone}
                severity="info"
                size="small"
                disabled={!id}
                onClick={() => this.testarConexao(routerboard)}
                model={itens}
                pt={{ button: { root: { className: 'mr-0' } } }}
                tooltip={contexto.traduzirHelp('testarconexao')}
                tooltipOptions={TooltipService.opcoesCampo(contexto, { autoHide: true })}
            />
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class RouterboardTemplate extends Component {

    state = { testeAcessoVisivel: false, testeAcessoUrl: '' };

    // A URL precisa ser resolvida no backend a cada chamada (não reaproveitar um valor cacheado
    // no login) - só assim reflete a publicação DONA da routerboard selecionada, não a do admin
    // logado (ver Routerboard.resolverUrlTesteAcesso, achado do card #99).
    abrirTesteAcesso = async () => {
        const routerboard = this.gridRef?.getSelected()?.[0];
        if (!routerboard) return;
        const res = await Routerboard.testarAcesso(routerboard);
        if (!res?.status) {
            UtilService.showToast({
                severity: 'error',
                summary:  UtilService.traduzir(res?.data?.state || 'main.routerboard.testeacesso.erro'),
                detail:   [res?.data?.mensagem, res?.data?.detalhes].filter(Boolean).join(' — '),
            });
            return;
        }
        this.setState({
            testeAcessoVisivel: true,
            testeAcessoUrl: res.data.url,
        });
    }

    processos() {
        return [
            {
                label:    'main.duplicar',
                icon:     'pi pi-clone',
                disabled: true,
                ativo: (processo, selected) => {
                    processo.disabled = selected.length !== 1;
                    return processo;
                },
                command: () => { this.gridRef?.duplicar(); },
            },
            {
                label:    'main.routerboard.testeacesso',
                icon:     'pi pi-mobile',
                disabled: true,
                ativo: (processo, selected) => {
                    processo.disabled = selected.length !== 1;
                    return processo;
                },
                command: () => this.abrirTesteAcesso(),
            },
        ];
    }

    render() {
        return (
            <>
                <EntityGrid
                    ref={(ref) => this.gridRef = ref}
                    entidade={Routerboard}
                    model={model}
                    identidade="main.routerboard"
                    permissoes={this.props.permissoes}
                    icone="pi-server"
                    storageKey="dt-routerboards"
                    processos={this.processos()}
                    renderers={renderers}
                    configuracao={this.props.configuracao}
                    navigate={this.props.navigate}
                    location={this.props.location}
                    searchparams={this.props.searchparams}
                    formulario={(m, ctx) => <RouterboardFormulario model={m} contexto={ctx} />}
                    formularioFooter={(m, ctx) => <RouterboardFooter model={m} contexto={ctx} />}
                />
                <Dialog
                    header={UtilService.traduzir('main.routerboard.testeacesso')}
                    visible={this.state.testeAcessoVisivel}
                    onHide={() => this.setState({ testeAcessoVisivel: false })}
                    contentStyle={{ display: 'flex', justifyContent: 'center' }}
                    style={{ width: 'fit-content' }}
                >
                    <div style={{
                        width: '375px',
                        height: '667px',
                        border: '10px solid #222',
                        borderRadius: '36px',
                        overflow: 'hidden',
                        boxShadow: '0 0 0 2px #555',
                    }}>
                        <iframe
                            title="teste-acesso-captive"
                            src={this.state.testeAcessoUrl}
                            style={{ width: '100%', height: '100%', border: 'none' }}
                        />
                    </div>
                </Dialog>
            </>
        );
    }
}

export default RouterboardTemplate;
